import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    fill: "none",
    height: "18",
    viewBox: "0 0 18 18",
    width: "18"
};
const _hoisted_2 = ["stroke-width"];
const _hoisted_3 = ["stroke-width"];
const _hoisted_4 = ["stroke-width"];
const _hoisted_5 = ["stroke-width"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'squares',
    props: {
        strokeWidth: { default: '1.4' }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    d: "M8 2H2V8H8V2Z",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": props.strokeWidth
                }, null, 8, _hoisted_2),
                _createElementVNode("path", {
                    d: "M17 2H11V8H17V2Z",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": props.strokeWidth
                }, null, 8, _hoisted_3),
                _createElementVNode("path", {
                    d: "M17 11H11V17H17V11Z",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": props.strokeWidth
                }, null, 8, _hoisted_4),
                _createElementVNode("path", {
                    d: "M8 11H2V17H8V11Z",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": props.strokeWidth
                }, null, 8, _hoisted_5)
            ]));
        };
    }
});
